export default "__VITE_ASSET__DdCP3$ZJ__"